import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IEstablecimiento,
  ICreateEstablecimiento,
  IListado,
  IQueryParam,
  IUpdateEstablecimiento,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class EstablecimientosService {
  constructor(private http: HttpService) {}

  public listar(
    queryParams?: IQueryParam
  ): Observable<IListado<IEstablecimiento>> {
    let params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/establecimientos`, { params });
  }

  public crear(dato: ICreateEstablecimiento): Observable<IEstablecimiento> {
    return this.http.post(`${api}/establecimientos`, dato);
  }

  public listarPorId(id: string): Observable<IEstablecimiento> {
    return this.http.get(`${api}/establecimientos/${id}`);
  }

  public editar(
    id: string,
    dato: IUpdateEstablecimiento
  ): Observable<IEstablecimiento> {
    return this.http.put(`${api}/establecimientos/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/establecimientos/${id}`);
  }
}
